import { render, staticRenderFns } from "./couponCategory.vue?vue&type=template&id=5594fe1e&scoped=true&"
import script from "./couponCategory.vue?vue&type=script&lang=js&"
export * from "./couponCategory.vue?vue&type=script&lang=js&"
import style0 from "./couponCategory.vue?vue&type=style&index=0&id=5594fe1e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5594fe1e",
  null
  
)

export default component.exports